import { render, staticRenderFns } from "./AssignRights.vue?vue&type=template&id=02e3dbb2&"
import script from "./AssignRights.vue?vue&type=script&lang=js&"
export * from "./AssignRights.vue?vue&type=script&lang=js&"
import style0 from "./AssignRights.vue?vue&type=style&index=0&id=02e3dbb2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports